exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  color: red;\n  background: #FFEBEE;\n  border: 1px solid red;\n  font-size: .85rem;\n  margin-top: 1px; }\n\n.warning {\n  color: #ff9e02;\n  background: #fff8e1;\n  border: 1px solid #ff9e02;\n  font-size: .85rem; }\n\n.broadcast {\n  color: #ff9e02;\n  background: #fff8e1;\n  border: 1px solid #ff9e02;\n  font-size: .85rem; }\n\n.infoBodyStyle {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1.25rem;\n  text-align: center;\n  color: #818182;\n  background-color: #fefefe;\n  position: relative;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem; }\n\n.infoIconStyle {\n  color: #ffcc00;\n  float: left; }\n\n.broadcastContiner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/message/message.component.scss
// module id = ../../../../../src/app/message/message.component.scss
// module chunks = main